export function isPast(date)  {
    let publishLater = new Date(date);
    let today = new Date();

    return publishLater <= today;
}
